const emailExpression =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const ahudLiteUrlExpression =
    /^(?!.*https?:\/\/(?!ahudesign\.swegon\.com\/light\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(?=\s|$)))[\s\S]*\bhttps:\/\/ahudesign\.swegon\.com\/light\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(?=\s|$)(?![\s\S]*https?:\/\/)/;
const urlExpression =
    /\b(?:https?|ftp|file):\/\/[^\s/$.?#].[^\s]*|\bwww\.[^\s/$.?#].[^\s]*|\b[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;

export const isValidEmail = (text: string) => {
    return text.length > 0 ? emailExpression.test(text) : false;
};
export const containsValidAhudLiteUrl = (text: string) => {
    return text.length > 0 ? ahudLiteUrlExpression.test(text) : false;
};
export const textContainsUrl = (text: string) => {
    return text.length > 0 ? urlExpression.test(text) : false;
};
